import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2113cddf&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=2113cddf&prod&lang=scss"
import style1 from "./Index.vue?vue&type=style&index=1&id=2113cddf&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2113cddf",
  null
  
)

export default component.exports